import { useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { REGISTER_ATHLETE, REGISTER_WITH_INVITE } from '../../apollo/mutations/user';
import AuthService from '../../auth/storage';
import useAuthInitializer from './useAuthInitializer';
import { setAuthState, setAuthError } from '../../redux/slices/authSlice';
import extractErrorMessage from '../../utils/extractErrorMessage';

const useRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { runAuthBootstrap } = useAuthInitializer();

  const [registerAthleteMutation] = useMutation(REGISTER_ATHLETE);
  const [registerWithInviteMutation] = useMutation(REGISTER_WITH_INVITE);

  const registerAthlete = async (formData) => {
    try {
      const { data } = await registerAthleteMutation({ variables: formData });
      const { token, user } = data.registerAthlete;

      AuthService.storeToken(token);
      dispatch(setAuthState(user));
      await runAuthBootstrap();
      navigate('/dashboard');

      return { success: true };
    } catch (err) {
      dispatch(setAuthError(extractErrorMessage(err)));
      throw err;
    }
  };

  const registerWithInvite = async ({ token, password, firstName, lastName, sports }) => {
    try {
      await registerWithInviteMutation({ variables: { token, password, firstName, lastName, sports } });
      return { success: true };
    } catch (err) {
      dispatch(setAuthError(extractErrorMessage(err)));
      throw err;
    }
  };
  
  return { registerAthlete, registerWithInvite };
};

export default useRegister;